import { ReactNode } from 'react';

export const controlClass =
  'rounded-lg border border-zt-border bg-zt-bg px-3 py-2 text-sm text-slate-200 placeholder-zt-muted focus:border-zt-primary focus:outline-none focus:ring-1 focus:ring-zt-primary';

export const primaryButtonClass =
  'flex items-center justify-center gap-1.5 rounded-lg bg-zt-primary px-3 py-2 text-sm font-medium text-zt-bg transition-colors hover:bg-zt-accent disabled:opacity-50';

export const secondaryButtonClass =
  'flex items-center justify-center gap-1.5 rounded-lg border border-zt-border bg-zt-surface px-3 py-2 text-sm font-medium text-slate-200 transition-colors hover:border-zt-primary hover:text-zt-primary disabled:opacity-50';

interface FilterBarProps {
  children: ReactNode;
  actions?: ReactNode;
}

function FilterBar({ children, actions }: FilterBarProps) {
  return (
    <div className="flex flex-col gap-3 rounded-xl border border-zt-border bg-zt-surface p-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex flex-wrap items-center gap-2">{children}</div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}

export default FilterBar;
